<template>
    <v-app :style="backgroundStyle">
    <!-- rerouting to ergebnisdienst -->
        <app-ergebnisdienst v-if="isErgebnisdienst" :ieBlock="ieBlock">
        </app-ergebnisdienst>
    <!-- forgot password -->
        <forgot-password v-else-if="userVerificationCompleted &&
                                !user.uid && $route.path === '/forgotPassword'"></forgot-password>
    <!-- verify if user token existing -->
        <verification v-else-if="!userVerificationCompleted"></verification>
    <!-- login or sign up if user unknown -->
        <authentication v-else-if="!user.uid" :ieBlock="ieBlock"></authentication>
    <!-- logged in -->
        <div v-else>
            <v-app-bar app color="primary" dark dense>
                <img width="40" src="./assets/oeskb.png"
                     style="background-color: white; border-radius: 20px;"
                     class="elevation-4 mr-3" @click="goToHome()">
                <div class="d-flex align-center heebo fs20" style="cursor: default"
                     @click="goToHome()">Mitgliederverwaltung</div>
                <v-spacer></v-spacer>
                <v-menu v-if="!permissionPass" bottom left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn dark icon v-bind="attrs" v-on="on">
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list max-height="600px" class="pa-0 overflow-y-auto">
                        <v-list-item @click="menueAction(ergebnisdienst)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ ergebnisdienst.icon }}</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ ergebnisdienst.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="permissionPass" @click="menueAction(passReferent)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ passReferent.icon }}</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ passReferent.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user.permissions.bowling || user.permissions.classic ||
                                           user.permissions.pass || user.permissions.passRead"
                                     @click="menueAction(searchSpieler)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ searchSpieler.icon }}</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ searchSpieler.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user.permissions.passRead || user.permissions.passRead ||
                                       user.permissions.classic || user.permissions.bowling"
                                     @click="menueAction(spielerExport)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ spielerExport.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ spielerExport.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item v-if="user.permissions.passRead"
                                     @click="menueAction(vereinsReporting)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ vereinsReporting.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ vereinsReporting.name }}</v-list-item-title>
                        </v-list-item>
                        <div v-if="permissionClassic || permissionPass">
                            <v-divider></v-divider>
                            <v-subheader >Classic</v-subheader>
                            <div v-for="(item, i) in classicItems" :key="i">
                                <v-list-item v-if="user.permissions['lv' + item.id] || permissionPass" @click="menueAction(item)">
                                    <v-list-item-title style="color: #ff3a2d">{{ item.id }} - {{ item.nameShort }}</v-list-item-title>
                                </v-list-item>
                            </div>
                        </div>
                        <div v-if="permissionBowling || permissionPass">
                            <v-divider></v-divider>
                            <v-subheader>Bowling</v-subheader>
                            <div v-for="(item, j) in bowlingItems" :key="j">
                                <v-list-item v-if="user.permissions['lv' + item.id] || permissionPass" @click="menueAction(item)">
                                    <v-list-item-title style="color: #5584c4 ">{{ item.id }} - {{ item.nameShort }}</v-list-item-title>
                                </v-list-item>
                            </div>
                        </div>
                        <v-divider></v-divider>
                        <v-list-item @click="menueAction(changePW)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ changePW.icon }}</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ changePW.name }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="menueAction(logout)">
                            <v-list-item-icon class="mr-2"><v-icon>{{ logout.icon }}</v-icon></v-list-item-icon>
                            <v-list-item-title>{{ logout.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn v-else dark icon @click.stop="drawer = !drawer">
                    <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
            </v-app-bar>
            <v-main>
                <router-view></router-view>
            </v-main>
            <v-navigation-drawer v-if="drawer" v-model="drawer" absolute temporary right>
                <div class="text-right">
                    <v-btn icon class="mt-1 mr-2" @click="drawer=false"><v-icon>mdi-close</v-icon></v-btn>
                </div>
                <v-list class="pa-0">
                    <v-list-item @click="menueAction(ergebnisdienst)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ ergebnisdienst.icon }}</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ ergebnisdienst.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="permissionPass" @click="menueAction(passReferent)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ passReferent.icon }}</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ passReferent.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="user.permissions.bowling || user.permissions.classic || user.permissions.pass"
                                 @click="menueAction(searchSpieler)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ searchSpieler.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ searchSpieler.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="user.permissions.pass || user.permissions.passRead ||
                                       user.permissions.classic || user.permissions.bowling"
                                 @click="menueAction(spielerExport)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ spielerExport.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ spielerExport.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="user.permissions.pass"
                                 @click="menueAction(spielerLoeschen)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ spielerLoeschen.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ spielerLoeschen.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item v-if="user.permissions.pass || user.permissions.passRead"
                                 @click="menueAction(vereinsReporting)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ vereinsReporting.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ vereinsReporting.name }}</v-list-item-title>
                    </v-list-item>
                    <v-divider></v-divider>
                    <div v-if="permissionClassic || permissionPass">
                        <v-subheader >Classic</v-subheader>
                        <div v-for="(item, i) in classicItems" :key="i">
                            <v-list-item v-if="user.permissions['lv' + item.id] || permissionPass" @click="menueAction(item)">
                                <v-list-item-title style="color: #ff3a2d">{{ item.id }} - {{ item.nameShort }}</v-list-item-title>
                            </v-list-item>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <div v-if="permissionBowling || permissionPass">
                        <v-subheader>Bowling</v-subheader>
                        <div v-for="(item, j) in bowlingItems" :key="j">
                            <v-list-item v-if="user.permissions['lv' + item.id] || permissionPass" @click="menueAction(item)">
                                <v-list-item-title style="color: #5584c4 ">{{ item.id }} - {{ item.nameShort }}</v-list-item-title>
                            </v-list-item>
                        </div>
                    </div>
                    <v-divider></v-divider>
                    <v-list-item @click="menueAction(changePW)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ changePW.icon }}</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ changePW.name }}</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="menueAction(logout)">
                        <v-list-item-icon class="mr-2"><v-icon>{{ logout.icon }}</v-icon></v-list-item-icon>
                        <v-list-item-title>{{ logout.name }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
        </div>
    <!-- loader -->
        <v-overlay :value="$store.state.local.loader" style="z-index: 15">
            <v-progress-circular indeterminate size="70" width="7" color="primary"></v-progress-circular>
        </v-overlay>
    <!-- snackbar -->
        <snackbar :msg="actionSnack"></snackbar>
    <!-- global snackbar -->
        <snackbar :msg="$store.state.globalSnack" style="z-index: 20" absolute></snackbar>
    </v-app>
</template>

<script>
import {db} from "./services/db";
import firebase from 'firebase/app'
import 'firebase/auth'
import Verification from "./views/authentication/verification";
import Authentication from "./views/authentication/authentication";
import {SportJahr} from "./services/data/sportJahr";
import ForgotPassword from "./views/authentication/forgotPassword";
import Snackbar from "./components/elements/snackbar";
import AppErgebnisdienst from "./AppErgebnisdienst";

export default {
    name: 'App',
    components: {
        AppErgebnisdienst,
        Snackbar,
        ForgotPassword,
        Authentication,
        Verification,
    },
    data: () => ({
        drawer: null,
        userVerificationCompleted: false,
        logout: { name: 'Abmelden', action: 'logout', icon: 'mdi-logout' },
        changePW: { name: 'Passwort ändern', action: 'changePW', icon: 'mdi-account-key' },
        passReferent: { name: 'Passreferent',  action: 'navigate', path: 'paesse', icon: 'mdi-account-supervisor-circle'},
        ergebnisdienst: { name: 'Ergebnisdienst',  action: 'navigate', path: 'Ergebnisdienst', icon: 'mdi-format-list-numbered'},
        searchSpieler: { name: 'Mitgliedersuche',  action: 'navigate', path: 'Spielersuche', icon: 'mdi-account-search'},
        vereinsReporting: { name: 'Vereine',  action: 'navigate', path: 'Vereinsreporting', icon: 'mdi-text-box'},
        spielerExport: { name: 'Spieler exportieren',  action: 'navigate', path: 'SpielerExport', icon: 'mdi-account-arrow-down'},
        spielerLoeschen: { name: 'Spieler löschen',  action: 'navigate', path: 'SpielerLoeschen', icon: 'mdi-account-remove'},
        actionSnack: {
            show: false,
            color: 'success',
            timeout: 5000,
            text: '',
            dynamicText: null,
            actionButtonI18n: '',
        },
        ieBlock: false,
    }),
    computed: {
        isErgebnisdienst() {
            return this.$route.path.indexOf('/Ergebnisdienst') !== -1
        },
        user () { return this.$store.state.user },
        permissionPass() { return this.$store.state.user.permissions ? 
                        this.$store.state.user.permissions.pass : false  },
        permissionClassic() { return this.$store.state.user.permissions ? 
                        this.$store.state.user.permissions.classic : false  },
        permissionBowling() { return this.$store.state.user.permissions ? 
                        this.$store.state.user.permissions.bowling : false  },
        classicItems(){
            return this.$store.state.local.landesverbaende.filter(lv => lv.sportart === 'classic');
        },
        bowlingItems(){
            return this.$store.state.local.landesverbaende.filter(lv => lv.sportart === 'bowling');
        },
        backgroundStyle(){
            return this.$route.path==='/Ergebnisdienst/Stream' ? 'background: none transparent; margin: 0;' : '';
        },
    },
    created(){
        this.$store.state.local.sportJahr = new SportJahr(null);
        this.verifyAuthentification();
        this.getVersion();
        this.checkCookieConsent();
        this.ieBlock = this.checkForIE();
    },
    methods: {
        checkForIE(){
            const ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
            const msie = ua.indexOf('MSIE '); // IE 10 or older
            const trident = ua.indexOf('Trident/'); //IE 11

            return (msie > 0 || trident > 0);
        },
        checkCookieConsent(){
            const cookieConsent = localStorage.getItem("cookieConsent");
            if ( !cookieConsent && this.$route.path !== '/Ergebnisdienst/showTv'
                && this.$route.path !== '/Ergebnisdienst/Stream' ) {
                this.$store.dispatch('clearSnackbar');
                this.$store.state.globalSnack.timeout = -1;
                this.$store.state.globalSnack.color = 'black';
                this.$store.state.globalSnack.text = 'Die auf dieser Webseite verwendeten Cookies ' +
                    'dienen ausschließlich dazu, die Funktionalität dieser Webseite zu gewährleisten. ' +
                    'Es werden keine persönlichen Daten erfasst!';
                this.$store.state.globalSnack.actionButtonI18n = 'Cookies akzeptieren';
                this.$store.state.globalSnack.header = 'Cookie Information';
                this.$store.state.globalSnack.actionMethod = this.setCookieConsent;
                this.$store.state.globalSnack.show = true;
            }
        },
            setCookieConsent(){
                this.$store.dispatch('clearSnackbar');
                this.$store.state.globalSnack.show = false;
                localStorage.setItem("cookieConsent", true);
            },
        getVersion(){
            db.collection('version').doc('version')
                .onSnapshot((doc) => {
                    this.checkVersion(doc.data().version);
                });
        },
            checkVersion(dbVersion){
                let currVersion = localStorage.getItem("Version");
                if ( dbVersion !== currVersion && dbVersion !== null && currVersion ) {
                // storage setzen
                    localStorage.setItem("Version", dbVersion);
                // neu laden
                    window.location.reload(true);
                } else if ( !currVersion ) {
                // storage setzen
                    localStorage.setItem("Version", dbVersion);
                }
            },
        verifyAuthentification() {
            firebase.auth().onAuthStateChanged(user => {
                if ( !user ) {
                    // logged out
                    this.userVerificationCompleted = true;
                    this.$store.commit('user/logout');
                    console.log ("is logged out")
                    this.setColor()
                } else {
                    // logged in
                    this.$store.commit('user/setFromAuthentication', user);
                    this.getAppUserData(user);
                    //this.userVerificationCompleted = true;
                    this.initialDbDocumentBind();
                    console.log ("is logged in", user)
                }
            });
        },
        async getAppUserData(user){
            let userData = await this.$store.dispatch('getTempSnapshot', {
                docId: user.uid,
                collection: 'users',
                //mutuation: 'user/setFromAppData'
            });
            this.$store.commit('user/setFromAppData', userData.content);
            this.userVerificationCompleted = true;
            this.setColor();
            /*if (dbGet) {
                // user sign completed
                this.$i18n.locale = this.$store.state.user.language;
                firebase.auth().languageCode = 'de';
                console.log ("user sign in completed");
                if ( this.user.admin ) {
                    this.bindDBAdminCollections();
                }
            } else {
                // user sign not yet completed
                console.log ("user sign in not yet completed");
            }*/
        },
        initialDbDocumentBind() {

        },
        menueAction(item){
            this.drawer = false;
            let path = item.path ? item.path : 'Landesverband';
            if ( item.action === 'changePW' ) {
                this.resetPW();
            } else if ( item.action === 'logout' ) {
                console.log ("logout" );
                this.drawer = false;
                firebase.auth().signOut();
            } else if ( (item.action === 'navigate' || !item.action ) &&
                    (this.$route.path !== '/' + path || this.$route.query.id !== item.id) ) {
                this.$router.push({path: path, query: {id: item.id}})
            }
        },
        resetPW(){
            this.drawer = false;
            firebase.auth().sendPasswordResetEmail(this.user.email)
            .then( () => {
                this.actionSnack.show = true;
                this.actionSnack.text = 'Du hast ein eMail mit einem Link zum Ändern des Passworts erhalten!';
            }).catch( (error) => {
                this.actionSnack.show = true;
                this.actionSnack.color = 'error';
                this.actionSnack.text = error.message;
            });
        },
        goToHome(){
            if ( this.$route.path !== '/' ) { this.$router.push('/') }
        },
        setColor(){
            // CHANGE PRIMARY COLOR PROGRAMMATICALLY!!!!
            if ( this.$route.path === '/Landesverband' && parseInt(this.$route.query.id) > 20 ||
                !this.user.permissions.pass && this.user.permissions.bowling && !this.user.permissions.classic ||
                (this.$route.path === '/Ergebnisdienst/AntiDoping' && this.$route.query.sportart==='Bowling')
            ) {
                this.$vuetify.theme.themes.light.primary = '#5584c4';
            } else {
                this.$vuetify.theme.themes.light.primary = '#ff3a2d';
            }
        }
    },
    watch: {
        '$route.query.id'(){
            this.setColor();
        },
        '$route.query.sportart'(){
            this.setColor();
        },
        'user.permissions'(to){
            if ( to ) this.$store.state.local.sportJahr = new SportJahr(this.user);
        }
    }
};
</script>
